import { ImageChip } from 'components/Chip/ImageChip';
import { pureComponent } from 'lib/pureComponent';
import React, { useCallback, useState } from 'react';
import { LayoutChangeEvent, StyleSheet, View } from 'react-native';

interface Props {
  ids: string[];
  idealTileWidth?: number;
  onRemove?: (id: string) => void;
  onPreview?: (fileId: string) => void;
  onDownload?: (fileId: string) => void;
  previewOnPress?: boolean;
  remoteUrl?: (fileId: string) => string;
}

export const ImageGrid: React.FC<Props> = pureComponent(
  ({
    ids,
    idealTileWidth = 100,
    onRemove,
    onPreview,
    onDownload,
    previewOnPress,
    remoteUrl,
  }) => {
    const [tileWidth, setTileWidth] = useState({ perRow: 1, width: 130 });

    const handleOnLayout = useCallback(
      ({ nativeEvent }: LayoutChangeEvent) => {
        const width = nativeEvent.layout.width - 25;
        const numberOfTilesInRow = Math.floor(width / idealTileWidth);
        setTileWidth({
          perRow: numberOfTilesInRow,
          width: width / numberOfTilesInRow - 2,
        });
      },
      [idealTileWidth],
    );

    return (
      <View style={styles.chips} onLayout={handleOnLayout}>
        {ids.map((id, index) => (
          <View
            key={`${id}-${index}`}
            style={{
              width: tileWidth.width,
              height: tileWidth.width,
              margin: 1,
              borderRadius: 6,
              overflow: 'hidden',
            }}
          >
            <ImageChip
              fileId={id}
              onRemove={onRemove}
              onPreview={onPreview}
              onDownload={onDownload}
              previewOnPress={previewOnPress}
              remoteUrl={remoteUrl}
              optionButtonSize={Math.min(44, tileWidth.width * 0.4)}
            />
          </View>
        ))}
      </View>
    );
  },
);

const styles = StyleSheet.create({
  chips: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginRight: -25,
  },
});
